import React, { useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { getAllAnnouncementAction } from '../../Redux/Actions/AnnouncementActions';

import './HAboutSection.css';

const HAboutSection = () => {
    const listRef = useRef(null);

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const announcementList = useSelector((e) => e?.AnnouncementReducer?.announcementList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllAnnouncementAction())
    }

    useEffect(() => {
        const list = listRef.current;
        if (!list) return;
        if (announcementList.length === 0) return;

        // Remove any previously cloned content (avoid duplicates)
        const existingClone = list.querySelector(".clone");
        if (existingClone) existingClone.remove();

        const listContent = list.querySelector("ul");
        if (!listContent) return;

        // Clone and mark the duplicate
        const clone = listContent.cloneNode(true);
        clone.classList.add("clone");
        list.appendChild(clone);

        let scroll = 0;
        const step = 0.3; // slower scroll speed
        const height = listContent.offsetHeight;
        let animationFrameId;

        const scrollList = () => {
            scroll += step;
            if (scroll >= height) scroll = 0;
            list.scrollTop = scroll;
            animationFrameId = requestAnimationFrame(scrollList);
        };

        animationFrameId = requestAnimationFrame(scrollList);

        // Cleanup
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, [announcementList]);

    return (
        <section
            className="about-announcement-section habout-section">
            <div className="container pb-4 pt-5">
                <div className="row">
                    <div className="col-md-8 mb-4">
                        <div className="bg-white p-4 h-100 rounded shadow-sm">
                            <h5 className="mb-4 text-primary fw-bold border-start border-4 ps-2">Centre of Excellence SPA NEW DELHI</h5>
                            <div className="row">
                                <div className="col-md-7 small">
                                    <p>
                                        The Centre of Excellence in Urban Planning and Design at SPA New Delhi, established under
                                        MoHUA, advances cutting-edge urban planning education, research, and practice in northern India.
                                        Serving as a hub for interdisciplinary collaboration, it connects academia, government, and industry
                                        to develop scalable, context-driven planning solutions. Key areas include transit-oriented
                                        development, impact assessments, climate resilience, and waste management. The Centre also
                                        creates planning tools, conducts capacity-building programs, and integrates fieldwork into
                                        academics. Its upcoming Urban Data Portal will support data-informed decisions. The CoE drives
                                        innovation and sustainable urban growth aligned with national and global priorities.
                                    </p>
                                </div>
                                <div className="col-md-5 row small text-center">
                                    <div><span className="fw-bold" style={{ color: '#8053A0', fontSize: '18px' }}>6+</span> Projects</div>
                                    <div><span className="fw-bold" style={{ color: '#8053A0', fontSize: '18px' }}>5+</span> Research</div>
                                    <div><span className="fw-bold" style={{ color: '#8053A0', fontSize: '18px' }}>12+</span> Training</div>
                                    <div><span className="fw-bold" style={{ color: '#F26C4F', fontSize: '18px' }}>14+</span> Collaboration</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4" >
                        <div className="bg-white p-4 h-100 rounded shadow-sm">
                            <h5 className="mb-4 text-primary fw-bold border-start border-4 ps-2">ANNOUNCEMENTS</h5>
                            {
                                isLoading ?
                                    <div className='text-center'>
                                        <Spinner animation="border" />
                                    </div>
                                    :
                                    // <>
                                    <div className="announcement-scroll" ref={listRef} >
                                        <ul className="list-unstyled small mb-0">
                                            {announcementList?.map((item, idx) => (
                                                <li
                                                    className="border-bottom py-2 announcement-link"
                                                    onClick={() => {
                                                        window.open(`https://api.coeupdspadelhi.in/uploads/${item?.file}`, '_blank');
                                                    }}
                                                    key={idx}
                                                >
                                                    {item?.title}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                // <div className="mt-3">
                                //     <a href="#" className="text-primary fw-bold">View More →</a>
                                // </div>
                                // </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HAboutSection;